export default __webpack_public_path__ + "static/media/best-plataform.904c51d1.svg";